import { Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';
import AdminLayout from './AdminLayout';
import Dashboard from './Dashboard';
import Users from './Users';
import UsefulLinksAdmin from './UsefulLinksAdmin';

const AdminRouter = () => {
    return (
        <Routes>
            <Route
                path="/admin/*"
                element={
                    <ProtectedRoute isAuthenticated={true}>
                        <AdminLayout />
                    </ProtectedRoute>
                }
            >
                <Route index element={<Navigate to="/admin/dashboard" />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="users" element={<Users />} />
                <Route path="useful-links" element={<UsefulLinksAdmin />} />
                {/* Add more routes as needed */}
            </Route>
        </Routes>
    );
};

export default AdminRouter;